var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit1SvgrepoCom({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-1-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.0013 4.66646H7.0013C5.71264 4.66646 4.66797 5.71112 4.66797 6.99979V20.9998C4.66797 22.2884 5.71264 23.3332 7.0013 23.3332H21.0013C22.29 23.3332 23.3346 22.2884 23.3346 20.9998V13.9998M21.4845 9.81636L22.7513 8.54965C23.6625 7.63842 23.6625 6.16104 22.7513 5.24982C21.84 4.3386 20.3627 4.3386 19.4514 5.24984L18.1847 6.51653M21.4845 9.81636L14.4422 16.8587C14.1165 17.1845 13.7016 17.4066 13.25 17.4969L9.81789 18.1833L10.5043 14.7513C10.5946 14.2995 10.8167 13.8847 11.1424 13.5589L18.1847 6.51653M21.4845 9.81636L18.1847 6.51653",
    stroke: "#545454",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit1SvgrepoCom);
export default __webpack_public_path__ + "static/media/edit-1-svgrepo-com.a2856608e220600c8fbf0671a9134b00.svg";
export { ForwardRef as ReactComponent };